export default () => ({
  select: {
    marginLeft: 15,
  },
});
